import { useLocation } from 'wouter';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../ui';
import AdminOverview from './AdminOverview';
import AdminContacts from './AdminContacts';
import AdminDemoRequests from './AdminDemoRequests';
import AdminCareers from './AdminCareers';
import AdminApplications from './AdminApplications';

export default function AdminDashboard() {
  const { username, logout, isAuthenticated, isLoading } = useAdminAuth();
  const [, navigate] = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    navigate('/admin/login');
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen" style={{ backgroundImage: "url('/assets/shared/simple-bg.png')", backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
      {/* Admin Header — matches website header style (blue ribbon), no nav menus */}
      <header className="sticky top-0 z-50 shadow-md" style={{ backgroundColor: '#1356a6' }}>
        <div className="w-full pl-3 pr-6 lg:pl-4 lg:pr-12 flex h-16 items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo/aiscendus-blue-bg.png"
              alt="AIscendus Logo"
              className="h-12 w-auto rounded-lg"
            />
            <span className="text-white/70 text-sm font-medium ml-2">Administration</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-white/70">
              Signed in as <span className="font-medium text-white">{username}</span>
            </span>
            <button
              onClick={handleLogout}
              className="inline-flex items-center rounded-md border border-white/30 bg-white/10 px-3 py-1.5 text-sm font-medium text-white hover:bg-white/20 transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>

      {/* Dashboard Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Tabs defaultValue="overview">
          <TabsList className="mb-6 flex-wrap">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="contacts">Contacts</TabsTrigger>
            <TabsTrigger value="demos">Demo Requests</TabsTrigger>
            <TabsTrigger value="careers">Careers</TabsTrigger>
            <TabsTrigger value="applications">Applications</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <AdminOverview />
          </TabsContent>
          <TabsContent value="contacts">
            <AdminContacts />
          </TabsContent>
          <TabsContent value="demos">
            <AdminDemoRequests />
          </TabsContent>
          <TabsContent value="careers">
            <AdminCareers />
          </TabsContent>
          <TabsContent value="applications">
            <AdminApplications />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
